"use client";

import { ConditionalAnalytics, CookieBanner } from "@/components/CookieConsent";
import { useCookieDictionary } from "@/lib/cookies/useCookieDictionary";

export function CookieComponents() {
  const cookieDictionary = useCookieDictionary();

  return (
    <>
      <CookieBanner dictionary={cookieDictionary} />
      <ConditionalAnalytics />
    </>
  );
}
